<template>
<div>
    <el-page-header @back="goBack" content="创建实例" v-if="parent">
    </el-page-header>
    <el-row class="container">
        <el-col :span="7">
            <el-card class="item">
                <div slot="header">
                    <div v-if="leftIndex==0">
                        <div class="item_nav" v-for="(nav, index) in filterNavs('rightIndex')"
                            :key="index" @click="chooseItem(nav, 'left')"
                             >
                            {{nav.name}}
                        </div>
                    </div>
                    <div v-else style="cursor:pointer;">
                        <span @click="handleTitle('left')" >{{filterTitle(leftIndex)}}</span>
                        <span v-if="!idcId"  style="float:right;" @click="backOperate('left')">撤销</span>
                    </div>
                </div>
                <div v-if="leftItem.id">
                    <device v-if="leftIndex == 1" :item="leftItem"/>
                    <unit v-if="leftIndex == 2" :item="leftItem"/>
                    <module v-if="leftIndex == 3" :item="leftItem"/>
                </div>
            </el-card>
        </el-col>
        <el-col align="center" :span="1">
            <div class="item icon">
                <el-button>+</el-button>
            </div>
        </el-col>
        <el-col :span="7">
            <el-card class="item">
                <div slot="header">
                    <div v-if="rightIndex==0">
                        <div class="item_nav" v-for="(nav, id) in filterNavs('leftIndex')"
                            :key="id" @click="chooseItem(nav, 'right')"
                        >
                            {{nav.name}}
                        </div>
                    </div>
                    <div v-else style="cursor:pointer;">
                        <span @click="handleTitle('right')">{{filterTitle(rightIndex)}}</span>
                        <span style="float:right;" @click="backOperate('right')">撤销</span>
                    </div>
                </div>
                <div v-if="rightItem.id">
                    <device v-if="rightIndex == 1" :item="rightItem"/>
                    <unit v-if="rightIndex == 2" :item="rightItem"/>
                    <module v-if="rightIndex == 3" :item="rightItem"/>
                </div>
            </el-card>
        </el-col>
        <el-col align="center" :span="1">
            <div class="item icon" title="创建实例">
                <el-button type="primary" @click="handleSource"
                           v-if="listOperations.some(func => func.name.includes('create_instance'))">=</el-button>
            </div>
        </el-col>
        <el-col :span="8">
            <el-card class="item">
                <div slot="header">
                    <span>实例</span>
                    <span style="float:right;">
                        <!-- <i class="el-icon-s-operation" style="margin-right: 4px; cursor: pointer;"
                            title="建立依赖关系"
                            @click="depend"></i> -->
                        <!-- <i class="el-icon-s-tools" style="cursor: pointer;"
                            title="设置实例信息"
                            @click="setInstance"></i> -->
                    </span>
                </div>
                <div style="padding: 14px;" v-if="instance.id">
                    <div>实例id: {{instance.id}}</div>
                    <!-- <div>实例别名：{{instance.alias}}</div>
                    <div>部署路径：{{instance.workspace}}</div> -->
                </div>
            </el-card>
        </el-col>
    </el-row>

    <device-list v-if="showDevice" :visible="showDevice" @chooseCallback="chooseCallback" @cancelCallback="cancelCallback"></device-list>
    <unit-list :visible="showUnit" @chooseCallback="chooseCallback" @cancelCallback="cancelCallback"/>
    <module-list :visible="showModule" :deviceId="deviceId" @chooseCallback="chooseCallback" @cancelCallback="cancelCallback"/>
    <!-- <set-source v-if="showSource" :visible="showSource"
     :deviceId="device.id" :module="module.name"
     @sourceCallback="sourceCallback"/> -->

    <instance-edit :id="instance.id"
        :visible="showInstanceDialog"
        @instanceEditCallback="instanceEditCallback"/>

    <!-- <count-down ref="countDown" :visible="timeShow" v-if="timeShow" @clearTime="timeShow=false"/> -->
</div>
</template>
<script>
import { Loading } from 'element-ui'
import Device from './Device.vue'
import DeviceList from './DeviceList.vue'
import Unit from './Unit.vue'
import UnitList from './UnitList.vue'
// import SetSource from './SetSource.vue'
// import Depend from './Dependency.vue'
import Module from './Module.vue'
import ModuleList from './ModuleList.vue'
import InstanceEdit from './InstanceEdit'
import CountDown from '@/components/common/CountDown'
import {mapMutations, mapState} from 'vuex';

export default {
  name: 'CreateInstance',
  components: { Device, DeviceList, Unit, UnitList, Module, ModuleList, InstanceEdit, CountDown },
  data: vm => ({
    leftIndex: 0,
    rightIndex: 0,
    leftItem: {
    }, //
    rightItem: {
    },
    active: '',
    showDevice: false,
    showUnit: false,
    showModule: false,
    showSource: false,
    navs: [
      {
        name: '设备',
        index: '1'
      },
      // {
      //     name: '网元',
      //     index: '2'
      // },
      {
        name: '模块',
        index: '3'
      }
    ],
    showDepend: false,
    device: {}, // 选中的设备
    module: {}, // 模块
    netunit: {}, // 网元
    instance: {
      id: ''
    }, // 实例
    parent: '',
    deviceId: null,
    idcId:null,
    showInstanceDialog: false,
    isLoading: false,
    timer: null,
    timeSecond: 60, // 倒计时 时间， 默认60S
    countDown: '<iframe src="@/assets/loading2.svg" />',
    timeShow: false
  }),
  created () {
    this.deviceId = parseInt(this.$route.query.deviceId)
    this.idcId = this.$route.query.idcId
    if(this.deviceId){
      this.findAll()
    }
    this.parent = this.$route.query.p
    this.getListOperations('instancecreate')
  },
  computed:{
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
  },
  methods: {
    ...mapMutations(['getListOperations']),
    goBack () {
      if(this.idcId){
        this.$router.push({
          path: 'idcdevicelist',
          name: 'idcdevicelist',
          params: {
            idcId: this.idcId
          }
        });
      }else {
        this.$router.push('instancelist')
      }
    },
    findAll() {
      let _this = this;
      this.$axios.get(this.baseUrl3 + "management3/device/findAll")
        .then(({ data: { msg, data, code } }) => {
          if(code == 20000){
            if(data && data.length > 0){
              _this.active = 'left'
              _this['leftItem'] = {}
              _this['leftIndex'] = '1'
              data.forEach( e => {
                if(e.id == _this.deviceId){
                  _this[_this.active + 'Item'] = e
                  _this.device = e
                }
              })

            }
          }else{
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        });
    },
    // nav类型选择
    chooseItem (nav, type) {
      this[type + 'Index'] = nav.index
      this.active = type
      this[type + 'Item'] = {}
      if (nav.index == 1) {
        this.showDevice = true
      } else if (nav.index == 2) {
        this.showUnit = true
      } else if (nav.index == 3) {
        this.showModule = true
      }
      this.instance.id = ""
    },
    // 点击标题重新选择
    handleTitle (type) {
      const idx = this[type + 'Index']
      this.active = type
      if (idx == 1) {
        if(!this.idcId){
          this.showDevice = true
        }
      } else if (idx == 2) {
        this.showUnit = true
      } else if (idx == 3) {
        this.showModule = true
      }
      this.instance.id = ""
    },
    // 显示的标题
    filterTitle (index) {
      let title = ''
      const nav = this.navs.filter(n => n.index == index)
      if (nav.length > 0) {
        title = nav[0].name
      }
      return title
    },
    // 选项
    filterNavs (index) {
      let arr = []
      if (this[index] == 0) {
        arr = this.navs
      } else if (this[index] == 1) {
        arr = this.navs.filter(n => n.index != 1)
      } else {
        arr = this.navs.slice(0, 1)
        index == 'leftIndex' ? this.rightIndex = 1 : this.leftIndex = 1
      }
      return arr
    },
    setSource () {
      this.$message.info('正在开发。。。')
    },
    chooseCallback (item) {
      if (item.id) {
        this[this.active + 'Item'] = item
        // this[this.active+'Index'] = 0
        if (item.type == 'device') {
          this.showDevice = false
          this.device = item
        } else if (item.type == 'unit') {
          this.showUnit = false
          this.netunit = item
        } else if (item.type == 'module') {
          this.module = item
          this.showModule = false
        }
      }
    },
    // 取消后关闭对应的弹框
    cancelCallback (dioalog) {
      this[dioalog] = false
    },
    handleSource () {
      if(Object.keys(this.leftItem).length == 0 || Object.keys(this.rightItem).length == 0){
          this.$message.warning('请先选择设备/网元/模块')
          return
      }
      // let loading = Loading.service({
      //   fullscreen: true,
      //   text: "数据加载中..."
      //   // spinner: 'el-icon-loading'
      // })
      // this.timeShow = true
      // return
      // 创建实例
      let model = {
        deviceId: this.device.id,
        moduleType: this.module.name,
        moduleVersion: this.module.version,
        hasServiceHelper: this.module.hasServiceHelper, //是否支持service-helper
        configs: this.module.configs, // 配置文件列表，上传过的文件信息
        integrationVersionAlias: this.module.unitInfo.alias, // 模块所属的集成
        integrationVersionVersion: this.module.unitInfo.version
      }
      this.$axios.post(this.baseUrl3 + 'instance/add', model)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$set(this.instance, 'id', data)
            // this.confirmPath()
            if(this.idcId){
              this.bind();
            }

          } else {
            this.$message({ showClose: true, message: msg, type: 'error' })
            console.log(msg)
          }
          // clearInterval(this.timer)
          // loading.close()
          // this.$refs['countDown'].cancel()
        })
        .catch(err => {
          // clearInterval(this.timer)
          console.log(err)
          // this.$refs['countDown'].cancel()
        })
    },
    bind(){
      let model = {
        deviceId: this.device.id,
        serviceAgentId: this.instance.id
      }
      this.$axios.post(this.baseUrl3 + 'management3/device/bind', model)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
          } else {
            this.$message({ showClose: true, message: msg, type: 'error' })
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 撤销
    backOperate (type) {
      this[type + 'Index'] = 0
      this[type + 'Item'] = {}
      this.active = ''

      let flag = ''
      if (type == 'left') {
        flag = 'right'
      } else {
        flag = 'left'
      }
      if (Object.keys(this[flag + 'Item']).length == 0) {
        this[flag + 'Index'] = 0
        this[flag + 'Item'] = {}
      }
      this.instance.id = ""
    },

    confirmPath () {
      this.$confirm('创建实例成功，是否继续设置实例别名等信息', '提示', {
        confirmButtonText: '是，设置实例',
        cancelButtonText: '否，跳到列表页',
        type: 'success'
      }).then(() => {
        this.showInstanceDialog = true
      }).catch(() => {
        this.goBack()
      })
    },

    // setInstance () {
    //   if (!this.instance.id) {
    //     this.$message.warning('请先创建实例')
    //     return
    //   }
    //   this.showInstanceDialog = true
    // },

    // 设置实例信息回调
    instanceEditCallback (val) {
      if (val != false) {
        this.instance.alias = val.alias
        this.instance.workspace = val.service.workspace
      }
      this.showInstanceDialog = false
    }

  }
}
</script>
<style scoped>
.container{
    padding: 15px;
}
.container .item{
    height: 200px;
}
.container .item.icon{
    display: table-cell;
    vertical-align: middle;
    cursor: pointer;
}
.container >>> .el-card__body{
    padding: 0px;
}
.item_nav{
    display: inline-block;
    cursor: pointer;
    padding: 0 8px;
    border-right: 1px solid #ccc;
}
.navItem{
    cursor: pointer;
}

.loadingIcon{
    width: 80px;
    height: 80px;
    animation: rotate 4s linear infinite;
}

@keyframes rotate{
	0%{
		transform: rotateZ(0deg);/*从0度开始*/
	}
	100%{
		transform: rotateZ(360deg);/*360度结束*/
	}
}

.svg_icon{
  width: 80px;
  height: 80px;
}
</style>
